export enum DaoCoinStatsOrderByVolume {
  Past1H = "volumeUsdPast1H",
  Past24H = "volumeUsdPast24H",
  Past7D = "volumeUsdPast7D",
  Past30D = "volumeUsdPast30D",
}

export enum DaoCoinStatsOrderByPrice {
  Past1H = "priceUsdPctChange1H",
  Past24H = "priceUsdPctChange24H",
  Past7D = "priceUsdPctChange7D",
  Past30D = "priceUsdPctChange30D",
}

export enum DaoCoinStatsOrderByPriceChange {
  Past1H = "priceUsdPctChange1H",
  Past24H = "priceUsdPctChange24H",
  Past7D = "priceUsdPctChange7D",
  Past30D = "priceUsdPctChange30D",
}

export interface TrendingTabSelection {
  timeDuration: string;
  priceAccessorKey: string;
  volumeAccessorKey: string;
  priceChangeAccessorKey?: string;
  orderBy: string;
}

export enum TrendingTimeRange {
  "1h" = "1h",
  "24h" = "24h",
  "7d" = "7d",
  "30d" = "30d",
}

export const trendingTabs: Array<TrendingTabSelection> = [
  {
    timeDuration: TrendingTimeRange["1h"],
    volumeAccessorKey: DaoCoinStatsOrderByVolume.Past1H,
    priceAccessorKey: DaoCoinStatsOrderByPrice.Past1H,
    priceChangeAccessorKey: DaoCoinStatsOrderByPriceChange.Past1H,
    orderBy: "priceUsdPctChange1H",
  },
  {
    timeDuration: TrendingTimeRange["24h"],
    volumeAccessorKey: DaoCoinStatsOrderByVolume.Past24H,
    priceAccessorKey: DaoCoinStatsOrderByPrice.Past24H,
    priceChangeAccessorKey: DaoCoinStatsOrderByPriceChange.Past24H,
    orderBy: "priceUsdPctChange24H",
  },
  {
    timeDuration: TrendingTimeRange["7d"],
    volumeAccessorKey: DaoCoinStatsOrderByVolume.Past7D,
    priceAccessorKey: DaoCoinStatsOrderByPrice.Past7D,
    priceChangeAccessorKey: DaoCoinStatsOrderByPriceChange.Past7D,
    orderBy: "priceUsdPctChange7D",
  },
  {
    timeDuration: TrendingTimeRange["30d"],
    volumeAccessorKey: DaoCoinStatsOrderByVolume.Past30D,
    priceAccessorKey: DaoCoinStatsOrderByPrice.Past30D,
    priceChangeAccessorKey: DaoCoinStatsOrderByPriceChange.Past30D,
    orderBy: "priceUsdPctChange30D",
  },
];

export const COLUMNS_WIDTH = [3, 18, 12, 12, 11, 10, 12, 9, 9, 4];

export enum TrendingFilterFields {
  tokenPublicKey = "tokenPublicKey",
}

export enum TrendingSortKeys {
  isBlacklisted = "isBlacklisted",
  isGreylisted = "isGreylisted",
}
